// Constants for different requests for current reducer
export default {
  employees: 'EMPLOYEES',
  createEmployee: 'CREATE_EMPLOYEE',
  updateEmployee: 'UPDATE_EMPLOYEE',
  deleteEmployee: 'DELETE_EMPLOYEE',
  updateEmployeeFormConst: 'UPDATE_EMPLOYEE_FORM',
  updateEmployeeBadge: 'UPDATE_EMPLOYEE_BADGE',
  employeeBadge: 'EMPLOYEE_BADGE',
  employeeClientEmailSettings: 'EMPLOYEE_CLIENT_EMAIL_SETTINGS',
  employeeSiteEmailSettings: 'EMPLOYEE_SITE_EMAIL_SETTINGS',
  employeeMobilePatrolEmailSettings: 'EMPLOYEE_MOBILE_PATROL_EMAIL_SETTINGS',
  updateEmployeeClientEmailSettings: 'UPDATE_EMPLOYEE_CLIENT_EMAIL_SETTINGS',
  updateEmployeeSiteEmailSettings: 'UPDATE_EMPLOYEE_SITE_EMAIL_SETTINGS',
  updateEmployeeMobilePatrolEmailSettings: 'UPDATE_EMPLOYEE_MOBILE_PATROL_EMAIL_SETTINGS',
};
